import type {PaymentInfo} from '../../model'
import type {PaymentMethodsResponse} from '../../repo/types'

export function toPaymentInfo(r: PaymentMethodsResponse): PaymentInfo {
  return {kind: r.body.selected_method.payment_method_kind}
}
